
import Vue from 'vue';
import { VFairUser } from '~/services/types/vfair';
import VFairService from '~/services/VFairService';

export default Vue.extend({
    name: 'VfairInviteCodeDialog',
    data() {
        return {
            code: '',
            error: false,
            loading: false,
        };
    },
    computed: {
        vFairUser: {
            get: function(): VFairUser | undefined {
                return (this as any).$interfaces.vfairModule.getVFairUser();
            },
            set: function(newValue: VFairUser): void {
                (this as any).$interfaces.vfairModule.setVFairUser(newValue);
            },
        },
        invited(): boolean {
            return !!this.vFairUser && this.vFairUser.invited;
        },
    },
    methods: {
        closeDialog() {
            (this as any).$interfaces.dialogModal.getState().resolver.res();
        },
        checkCodeClick(): void {
            if (!!this.vFairUser) {
                this.loading = true;
                VFairService.setVFairUser(
                    {
                        userId: this.vFairUser.userId,
                        vfairId: this.vFairUser.vfairId,
                        interested: true,
                        invited: true,
                    },
                    this.code
                )
                    .then(user => {
                        this.vFairUser = user;
                        this.error = false;
                    })
                    .catch(() => {
                        this.error = true;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
    },
});
